import { Suspense, lazy, useEffect } from "react";
import { useParams } from "react-router";
import FullScreenLoadingSpinner from "src/components/shared/loading/FullScreenLoadingSpinner";
import { usePublicFormTemplateGroup } from "src/hooks/forms/formTemplateGroups/usePublicFormTemplateGroup";
import { useAnonmyousPatientV2 } from "src/hooks/patients/useAnonymousPatientV2";
import { retry } from "src/utils/lazy";

const AnonymousPatientInfo = lazy(() => retry(() => import("./AnonymousPatientInfo")));

const AnonymousPatientFormsPublicV2: React.FC = () => {
    const {
        formTemplateGroupPublicUuid,
        locationId,
    }: {
        accountPublicUuid: string | undefined;
        formTemplateGroupPublicUuid: string | undefined;
        locationId: string | undefined;
    } = useParams();

    const [formTemplateGroup] = usePublicFormTemplateGroup(formTemplateGroupPublicUuid);
    useEffect(() => {
        if (formTemplateGroup?.name) {
            document.title = `${formTemplateGroup.name} - ${
                formTemplateGroup?.account?.name || "Lobbie"
            }`;
        } else {
            document.title = formTemplateGroup?.account?.name || "Lobbie";
        }
    }, [formTemplateGroup?.name, formTemplateGroup?.account?.name]);

    const { create: createAccountPatient, isLoading: isLoadingCreatePatient } =
        useAnonmyousPatientV2(formTemplateGroup?.account.publicUuid, {
            locationId,
            formTemplateGroupPublicUuid,
        });

    if (!formTemplateGroup?.account?.publicUuid) {
        return <FullScreenLoadingSpinner />;
    }

    return (
        <Suspense fallback={<FullScreenLoadingSpinner message="Loading..." />}>
            <AnonymousPatientInfo
                account={formTemplateGroup.account}
                formTemplateContainer={formTemplateGroup}
                createAccountPatient={createAccountPatient}
                isLoadingCreatePatient={isLoadingCreatePatient}
            />
        </Suspense>
    );
};

export default AnonymousPatientFormsPublicV2;
